import { Button, ButtonProps, Icon } from "@chakra-ui/react";
import { ElementType } from "react";

interface GreenStatusButtonProps extends ButtonProps {
  icon: ElementType;
  children: string;
  iconProps?: object;
}

export default function GreenStatusButton({ icon, iconProps = {}, children, ...rest }: GreenStatusButtonProps) {
  return (
    <Button
      leftIcon={icon ? <Icon as={icon} boxSize="3" {...iconProps} /> : undefined}
      variant="outline"
      colorScheme="sentGreen"
      color="sentGreen.500"
      fontWeight="bold"
      border="1.25px solid"
      fontSize="sm"
      py={0}
      h="32px"
      w="auto"
      cursor="auto"
      sx={{
        "span:first-of-type": {
          marginInlineEnd: ".25rem",
        },
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}
